module.exports = __webpack_public_path__ + "img/bonus_on.218b08dc.png";